export const boardEntityTypes = {
  BOARD: 'BOARD',
  BASIC_BOARD: 'BASIC_BOARD',
  COUNCIL: 'COUNCIL',
};
